import { useTheme } from "../ThemeProvider";

/** Fondo de la imagen del telón (docs/gestion-ventas-telon). */
const TELON_BG = "#0b0b0d";

/**
 * Pantalla de reposo cuando no hay expediente seleccionado ni en alta.
 */
export default function TelonGestionVentas() {
  const { theme } = useTheme();
  const bgApp = theme.colors.bgApp;
  const isDark = theme.name === "dark";

  return (
    <div
      aria-hidden="true"
      style={{
        flex: 1,
        minHeight: 0,
        position: "relative",
        overflow: "hidden",
        background: bgApp,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: TELON_BG,
        }}
      />
      <img
        src="/gestion-ventas-telon.png"
        alt=""
        draggable={false}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center center",
          userSelect: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: isDark
            ? `radial-gradient(ellipse 115% 95% at 50% 44%, transparent 58%, ${bgApp} 100%)`
            : `radial-gradient(ellipse 92% 78% at 50% 42%, transparent 42%, ${bgApp} 92%),
               linear-gradient(180deg, ${bgApp} 0%, transparent 14%, transparent 86%, ${bgApp} 100%)`,
        }}
      />
    </div>
  );
}
